import { getFormattedDate } from "../../../../../ReadAndWrite/ReadAndWrite/utils";
import { Checkbox } from "@vebox/etui-core";
import { EQ_TABLES_INDEXES, EQ_TABLES_NAMES } from "../../types";
import * as React from "react";
import { FindEquipmentListElement } from "./types";
import { uuid, VeboxModels } from "../../../../../types/veboxModels";
import { Column } from "react-table";

const valueOrDefault = (value: string | undefined): string => value ?? "-";

export const createDatasource = (
	list: VeboxModels.JSONEquipment[],
	removeAction: (equipmentGuid: uuid) => (event) => void,
	selectedEquipment: uuid[],
	areAllSelected: boolean,
): FindEquipmentListElement[] => {
	const regexToRemoveLocale = /\[.*?]/g;
	return list?.map((jsonCensusEquipment: VeboxModels.JSONEquipment) => {
		const equipment = jsonCensusEquipment?.core;
		const installation = jsonCensusEquipment?.equipmentInstallation;
		const installationDate = installation?.installationDate.replace(
			regexToRemoveLocale,
			"",
		);
		const location = installation?.plant?.location;
		const eq: FindEquipmentListElement = {
			code: valueOrDefault(
				equipment?.customerCode?.code ?? equipment?.manufacturerCode?.code,
			),
			name: valueOrDefault(equipment?.name),
			model: valueOrDefault(equipment?.model?.name),
			location: valueOrDefault(location?.description),
			since: valueOrDefault(
				getFormattedDate({ dateToFormat: installationDate }),
			),
			all: (
				<Checkbox
					name={"select-" + equipment?.guid}
					defaultChecked={true}
					checked={
						areAllSelected || selectedEquipment?.includes(equipment?.guid)
					}
					onChange={removeAction ? removeAction(equipment?.guid) : undefined}
				/>
			),
		};
		return eq;
	});
};

const renderHeader = (
	title: string,
	removeAllAction: (event) => void,
	areAllSelected: boolean,
): JSX.Element => {
	if (title === EQ_TABLES_NAMES.ALL) {
		return (
			<h2 className={"checkbox-all"}>
				<Checkbox
					name={"select-all"}
					onChange={removeAllAction}
					checked={areAllSelected}
					style={{ width: "18px", height: "20px" }}
				/>
			</h2>
		);
	}
	return <>{title}</>;
};

export const createColumnElement = (
	title: string | EQ_TABLES_NAMES,
	dataIndex: string,
	removeAllAction?: (event) => void,
	areAllSelected: boolean = false,
): Column<any> => ({
	id: dataIndex,
	Header: renderHeader(title, removeAllAction, areAllSelected),
	accessor: dataIndex,
});

export const createColumnsList = (
	getTableHeadersName: (name: EQ_TABLES_NAMES) => string,
	removeAllAction: (event) => void,
	areAllSelected: boolean,
): readonly Column<any>[] => {
	return [
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.NAME),
			EQ_TABLES_INDEXES.NAME,
		),
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.CODE),
			EQ_TABLES_INDEXES.CODE,
		),
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.MODEL),
			EQ_TABLES_INDEXES.MODEL,
		),
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.LOCATION),
			EQ_TABLES_INDEXES.LOCATION,
		),
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.SINCE),
			EQ_TABLES_INDEXES.SINCE,
		),
		createColumnElement(
			getTableHeadersName(EQ_TABLES_NAMES.ALL),
			EQ_TABLES_INDEXES.ALL,
			removeAllAction,
			areAllSelected,
		),
	];
};
